const OVERLAY_CLASS = "loading-overlay";

export function showLoading(container: HTMLElement): void {
  if (container.querySelector(`.${OVERLAY_CLASS}`)) return;
  const overlay = document.createElement("div");
  overlay.className = OVERLAY_CLASS;
  overlay.innerHTML = `<div class="loading-spinner"></div>`;
  container.style.position = "relative";
  container.appendChild(overlay);
}

export function hideLoading(container: HTMLElement): void {
  container.querySelector(`.${OVERLAY_CLASS}`)?.remove();
}
